<template>
  <div>
    <!-- pc 轮播 -->
    <template v-if="$screen.md">
      <b-carousel
        v-if="indexData && indexData.banners"
        id="carousel-1"
        ref="myCarousel"
        v-model="slide"
        :interval="3000"
        indicators
      >
        <!-- 修改 aria-label 属性 -->
        <b-carousel-slide
          aria-label="第一张幻灯片"
          v-for="item in indexData.banners"
          :key="item.id"
        >
          <template v-slot:img>
            <div
              class="tw-flex tw-items-center tw-justify-center"
              style="background: #e0e8f5; width: 100%; position: relative"
              @click="handleLink(item)"
            >
              <!-- 判断是否为视频格式 -->
              <template v-if="isVideo(item.img)">
                <video
                  class="d-block w-100 carousel-video"
                  style="
                    object-fit: cover;
                    object-position: center;
                    width: 100%;
                    height: 100%;
                  "
                  autoplay
                  muted
                  loop
                >
                  <source :src="item.img" type="video/mp4" />
                </video>
              </template>
              <!-- 图片格式 -->
              <template v-else>
                <img
                  class="d-block w-100 h-100"
                  :src="item.img"
                  alt=""
                  style="
                    object-fit: contain;
                    object-position: center;
                    width: 100%;
                    height: 100%;
                  "
                />
              </template>

              <div
                style="position: absolute; bottom: 32%; left: 8.4%; color: #fff"
                class="slide-title slide-content"
              >
                <div>
                  <div
                    class="tw-text-textMain slide-name tw-font-bold slide-animate"
                  >
                    {{ item.name }}
                  </div>
                  <p
                    class="slide-desc tw-text-textLight tw-text-lg slide-animate"
                  >
                    {{ item.desc }}
                  </p>
                </div>
                <div
                  class="slide-but tw-text-textMain tw-text-sm slide-animate"
                >
                  了解详情
                </div>
              </div>
              <div
                class="carousel-cont tw-flex tw-justify-center tw-items-center tw-gap-16"
              >
                <div
                  v-for="(item, index) in tabs"
                  :key="index"
                  class="tw-h-full tw-flex tw-flex-col tw-justify-center tw-items-center tw-w-64 tw-cursor-pointer hover:tw-bg-white tw-transition tw-duration-300 tw-ease-in-out"
                  @click.stop="handlePath(item)"
                >
                  <h3 class="tw-font-bold tw-text-lg tw-text-textMain">
                    {{ item.name }}
                  </h3>
                  <p class="tw-text-sm tw-mb-0 tw-text-textLight">
                    {{ item.desc }}
                  </p>
                </div>
              </div>
            </div>
          </template>
        </b-carousel-slide>
      </b-carousel>
    </template>
    <!-- 移动端 -->
    <template v-else>
      <div class="tw-bg-bgMain">
        <b-carousel
          v-if="indexData && indexData.banners"
          id="carousel-1"
          ref="myCarousel"
          v-model="slide"
          :interval="3000"
          indicators
        >
          <!-- 修改 aria-label 属性 -->
          <b-carousel-slide
            aria-label="第一张幻灯片"
            v-for="item in indexData.banners"
            :key="item.id"
            img-height="auto"
          >
            <template v-slot:img>
              <div
                class="tw-flex tw-items-center tw-justify-center"
                style="background: #e0e8f5; width: 100%; position: relative"
                @click="handleLink(item)"
              >
                <img
                  class="d-block w-100"
                  :src="item.mobilePhoneImg"
                  alt=""
                  style="
                    object-fit: contain;
                    object-position: center;
                    width: 100%;
                    height: auto;
                  "
                />

                <div
                  style="
                    position: absolute;
                    bottom: 16%;
                    left: 8.4%;
                    color: #fff;
                  "
                  class="slide-content"
                >
                  <div class="slide-title2">
                    <h5 class="tw-text-textMain tw-font-bold slide-animate">
                      {{ item.name }}
                    </h5>
                    <p
                      class="slide-desc2 tw-text-textLight tw-text-xs slide-animate"
                    >
                      {{ item.desc }}
                    </p>
                  </div>
                </div>
              </div>
            </template>
          </b-carousel-slide>
        </b-carousel>
        <div
          class="tw-bg-bgMain tw-mt-4 tw-px-4 tw-grid tw-grid-cols-2 tw-items-center tw-gap-4"
        >
          <div
            v-for="(item, index) in tabs"
            :key="index"
            class="tw-h-full tw-bg-white tw-rounded-lg tw-py-5 tw-flex tw-flex-col tw-justify-center tw-items-center"
            @click.stop="handlePath(item)"
          >
            <h4 class="tw-font-bold tw-text-base tw-text-textMain">
              {{ item.name }}
            </h4>
            <p class="tw-text-sm tw-mb-0 tw-text-textLight">
              {{ item.desc }}
            </p>
          </div>
        </div>
      </div>
    </template>
  </div>
</template>

<script>
import authMixin from "@/mixins/authMixin";
export default {
  data() {
    return {
      slide: 0,
      sliding: null,
      carouselList: [],
      videoElements: new Map(),
      tabs: [
        {
          name: this.$t("云服务"),
          desc: this.$t("智能发现，一键部署"),
          path: "/cloud",
          id: 1,
        },
        {
          name: this.$t("最新动态"),
          desc: this.$t("掌握公司前沿技术发布"),
          path: "/dynamics",
          id: 2,
        },
        {
          name: this.$t("个人空间"),
          desc: this.$t("专属企业资源与工具"),
          path: "/controlCenter/personal-setting",
          id: 3,
        },
        {
          name: this.$t("活动"),
          desc: this.$t("汇聚研讨，一览俱全"),
          path: "/activity",
          id: 4,
        },
      ],
    };
  },
  computed: {
    indexData() {
      return this.$store.state.indexInfo;
    },
  },
  created() {},
  mixins: [authMixin],
  methods: {
    // 添加判断是否为视频的方法
    isVideo(src) {
      if (!src) return false;
      return src.toLowerCase().endsWith(".mp4");
    },

    handleLink(item) {
      window.open(item.url, "_blank");
    },

    handleClick(item, index) {
      this.$refs.myCarousel.setSlide(index); // 直接设置 slide 值以触发轮播
    },

    prev() {
      this.$refs.myCarousel.prev();
    },

    next() {
      this.$refs.myCarousel.next();
    },

    handlePath(item) {
      const { id, path } = item;
      if (id === 3) {
        // 检查用户是否登录,使用封装的方法
        if (!this.checkLoginAndRedirect()) return;
      }
      if (path === "/activity") {
        localStorage.setItem("redirectUrl", "/activity");
      }
      this.$router.push(path);
    },
  },
};
</script>
<style lang="scss" scoped>
.carousel-box {
  position: absolute;
  bottom: 20%;
  left: 15%;
  display: flex;
  flex-direction: column;

  .carousel-box_list {
    margin-right: 10px;
    cursor: pointer;
    width: 40px;
    height: 6px;
    z-index: 999;
    border: 1px solid #fff;
    border-radius: 3px;
  }

  .carousel-box_list-show {
    background: #fff;
  }
  .carousel-button {
    position: absolute;
    bottom: 20px;
    right: 20px;
    z-index: 999;
  }
}
::v-deep .carousel-indicators {
  bottom: 100px; /* 向上移动的距离 */
  margin-bottom: 0; /* 清除默认的margin */
}

.slide-name {
  font-size: 48px;
}
.slide-title {
  max-width: 600px;
}
.slide-title2 {
  width: 200px;
}
.slide-desc {
  min-height: 100px;
  margin-top: 20px;
}
.slide-desc2 {
  min-height: 60px;
}
.slide-but {
  width: 120px;
  text-align: center;
  padding: 8px;
  border-radius: 4px;
  cursor: pointer;
  color: #fff;

  background: linear-gradient(90deg, #3d4bdf 0%, #4077f8 100%);
}
::v-deep .carousel-inner {
  // max-height: 600px;
}
.slide-animate {
  opacity: 0;
  transform: translateY(50px);
  animation: slideUp 0.8s ease-out forwards;
}

/* 延迟动画 */
.slide-animate:nth-child(1) {
  animation-delay: 0.3s;
}

.slide-animate:nth-child(2) {
  animation-delay: 0.6s;
}

.slide-animate:nth-child(3) {
  animation-delay: 0.9s;
}
.carousel-cont {
  backdrop-filter: blur(20px);
  background: hsla(0, 0%, 94%, 0.7);
  bottom: 0;
  height: 88px;
  position: absolute;
  width: 100%;
  z-index: 39;
}

/* 动画关键帧 */
@keyframes slideUp {
  0% {
    opacity: 0;
    transform: translateY(50px); /* 从下方50px开始 */
  }
  100% {
    opacity: 1;
    transform: translateY(0); /* 移动到原始位置 */
  }
}
@media (max-width: 1380px) {
  .slide-title {
    max-width: 400px;
  }
  .slide-desc {
    min-height: 60px;
    margin-top: 10px;
    font-size: 14px;
  }
  .slide-name {
    font-size: 24px;
  }
  .slide-but {
    width: 100px;
    padding: 4px 8px;
  }
  .carousel-cont {
    backdrop-filter: blur(20px);
    background: hsla(0, 0%, 94%, 0.7);
    bottom: 0;
    height: 60px;
    position: absolute;
    width: 100%;
    z-index: 39;
    p {
      font-size: 12px;
    }
    h3 {
      font-size: 14px;
      margin-bottom: 0px;
    }
  }
}
@media (max-width: 768px) {
  ::v-deep .carousel-indicators {
    bottom: 10px; /* 向上移动的距离 */
    margin-bottom: 0; /* 清除默认的margin */
  }
}
</style>
